<section *ngIf="product" class="text-gray-600 body-font overflow-hidden pb-32 flex flex-col justify-stretch">
  <div class="w-full h-12 bg-white flex flex-row items-center mb-4">
    <a [routerLink]="['/home']" class="h-full w-12 flex items-center justify-center"><img
        src="../../../assets/graphics/home_24dp_FILL0_wght400_GRAD0_opsz24.svg" style="width: 24px; height: 24px" /></a>

    <svg class="shrink-0 min-w-6 max-w-6 opacity-50" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor"
      aria-hidden="true">
      <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"></path>
    </svg>

    <a [routerLink]="['/', product.category!.slug]"
      class="h-full w-64 shrink-0 flex text-nowrap items-center justify-center ml-4 text-sm mr-4 text-[#ff4d06]">
      {{ product.category!.label }}
    </a>
    <svg class="shrink-0 w-6 opacity-50" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor"
      aria-hidden="true">
      <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"></path>
    </svg>
  </div>
  <div class="container px-8 xs:px-4 xs:py-8 sm:py-4 md:py-24 mx-auto w-full" id="spec_sheet">
    <div class="lg:w-4/5 mx-auto flex flex-wrap">
      <!-- <img alt="ecommerce" class="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded" src="https://dummyimage.com/400x400"> -->
      <div class="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded p-4">
        <div class="p-8 relative animate__animated animate__animated">
          <app-image-carousel [isSS]="!isSS" [images]="images" [product]="product"></app-image-carousel>
        </div>
        <div style="color: #ff4d06" *ngIf="!isSS" class="flex justify-center">
          <p style="text-align: center">Click on image to enlarge</p>
        </div>
      </div>

      <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0 pt-[180px]">
        <!-- <h2 class="text-sm title-font text-gray-500 tracking-widest">BRAND NAME</h2> -->
        <h1 [ngClass]="{ 'animate__animated ': !isSS }"
          class="text-[#ff4d06] pb-4 text-2xl md:text-3xl title-font font-medium mb-1 animate__fadeInRight">
          {{ product.label }}
        </h1>



        <span class="animate__animated animate__fadeIn" [innerHTML]="fullSpec()">
        </span>



        <youtube-player [videoId]="product.embed" class="border-md  " [width]="360" [height]="220"></youtube-player>

        <p class="text-xl title-font" *ngIf="product.warranty !== undefined && product.warranty !== null">
          {{ product.warranty | uppercase }} WARRANTY
        </p>

        <div *ngIf="isSS" class="flex flex-col pb-32">
          <span *ngIf="product!.availability === 'PRE_ORDER'" class="text-lg text-red-600">Early Reservation Only</span>
          <span *ngIf="product!.availability === 'IN_STOCK'" class="text-lg text-red-600">In Supply</span>

          <span *ngIf="product!.availability === 'OUT_OF_STOCK'" class="text-lg text-red-600">Sold Out</span>

          <h3 *ngIf="!product!.pleaseContactForPrice" class="flex title-font font-medium !text-center text-4xl text-black"
            style="text-align: center !important; width: 100%">
            {{ product!.newPrice! | currency: "Rs. " : "Rs." : "1.0-0" }}
          </h3>

          <div *ngIf="!product!.pleaseContactForPrice && product!.discounted">
            <span class="text-center text-[#ff4d06] font-bold text-xl">
              {{ "Exclusive Deal" | uppercase }}
            </span>
            <p class="title-font text-xl text-black mt-2">
              was
              {{ product!.previousPrice | currency: "Rs." : "Rs." : "1.0-0" }}
            </p>
          </div>

          <div *ngIf="product!.pleaseContactForPrice" class="flex flex-col items-center justify-center py-4">
            <span class="text-lg uppercase text-gray-500 font-semibold">Contact for pricing</span>
            <span class="text-4xl font-extrabold text-red-600 mt-1 cursor-pointer" (click)="callNumber('0772553478')">0772553478</span>
          </div>
          <small>{{ date | date: "medium" }}</small>
        </div>

        <div *ngIf="!isSS" class="flex flex-col w-full">
          <div class="flex flex-row " style="padding-bottom: 16px;">
            <div *ngIf="product!.availability === 'PRE_ORDER'"
              class="bg-yellow-300 text-red-800 w-full text-lg rounded-md font-medium me-2 px-2.5 py-0.5 text-center justify-center">
              <span class="text-lg">Early Reservation Only</span>
            </div>

            <div *ngIf="product!.availability === 'IN_STOCK'"
              class="bg-yellow-300 text-red-800 w-full text-lg rounded-md font-medium me-2 px-2.5 py-0.5 text-center justify-center flex flex-col">
              <span>In Supply</span>
            </div>

            <div *ngIf="product!.availability === 'OUT_OF_STOCK'"
              class="bg-red-800 text-yellow-300 w-full text-lg rounded-md font-medium me-2 px-2.5 py-0.5 text-center justify-center">
              <span>Sold Out</span>
            </div>


            <div *ngIf="product!.brandNew && !product!.used"
              class="bg-red-500 text-amber-400   text-lg rounded-md font-medium me-2 px-2.5 py-0.5 text-center w-44 justify-center">
              <span>Brand New</span>
            </div>

            <div *ngIf="!product!.brandNew && product!.used"
              class="bg-orange-400 text-white w-32 text-lg rounded-md font-medium me-2 px-2.5 py-0.5 text-center justify-center">
              <span>Used</span>
            </div>

          </div>

          <div class="flex flex-col">
            <div class="flex flex-col w-full bg-[#ff4d06] rounded-xl p-4" *ngIf="!product!.pleaseContactForPrice">
              <div class="bg-white rounded-lg justify-center content-center flex flex-row p-4">
                <div class="flex flex-row justify-center">
                  <h3 class="flex title-font font-medium !text-center text-4xl text-black"
                    style="text-align: center !important; width: 100%">
                    {{
                    product!.newPrice! | currency: "Rs. " : "Rs." : "1.0-0"
                    }}
                  </h3>
                </div>
              </div>

              <div *ngIf="product!.discounted">
                <div class="flex flex-col justify-center items-center pt-2">
                  <span class="text-center text-white font-bold text-4xl">
                    {{ "Exclusive Deal" | uppercase }}
                  </span>
                  <p class="title-font text-xl text-black mt-2">
                    was
                    <span class="line-through" aria-label="previous price">
                      {{
                      product!.previousPrice
                      | currency: "Rs." : "Rs. " : "1.0-0"
                      }}</span>
                  </p>
                </div>
              </div>

            </div>

            <!-- Contact info container when pleaseContactForPrice is true -->
            <div class="flex flex-col w-full bg-[#ff4d06] rounded-xl p-4 cursor-pointer animate__animated animate__pulse animate__infinite"
              *ngIf="product!.pleaseContactForPrice"
              (click)="callNumber('0772553478')">
              <div class="bg-white rounded-lg justify-center content-center flex flex-col p-4 text-center">
                <span class="text-sm uppercase tracking-[0.2em] text-gray-500 font-semibold">Contact for pricing</span>
                <h2 class="text-3xl font-extrabold text-red-600 mt-1">
                  0772553478
                </h2>
              </div>
            </div>
            <br>



          </div>

          <div class="pt-4 flex flex-wrap gap-4 justify-stretch ">

            <!-- <button matTooltip="Add to Cart, download the PDF later from the cart" (click)="addToCart()"
              aria-label="add to Cart button"
              class="text-[#ff4d06] bg-black border-0 py-2 px-6 focus:outline-none hover:bg-red-900 rounded font-bold text-2xl flex w-full items-center justify-center">
              <div class="flex flex-row gap-4 w-full justify-center">
                <span> PURCHASE</span>
                <img src="../../../assets/graphics/add_shopping_cart_FILL0_wght400_GRAD0_opsz24.svg" width="24"
                  height="24" loading="eager" />
              </div>
            </button>
-->
            <!-- <button matTooltip="Add to Cart, download the PDF later from the cart" (click)="addToCart()"
              aria-label="add to Cart button"
              class="text-[#ff4d06] bg-black border-0 py-2 px-6 focus:outline-none hover:bg-red-900 rounded font-bold text-2xl flex w-full items-center justify-center">
              <div class="flex flex-row gap-4 w-full justify-center">
                <span> ADD TO CART </span>
                <img src="../../../assets/graphics/add_shopping_cart_FILL0_wght400_GRAD0_opsz24.svg" width="24"
                  height="24" loading="eager" />
              </div>
            </button> -->



            <!-- HTML !-->


            <!-- HTML !-->

            <ng-container *ngIf="!product!.pleaseContactForPrice">
              <div *ngIf="product!.newPrice! <=10000" class="  flex w-full  ">
                <button (click)="purchaseNow()" class="button-82-pushable  w-full flex" role="button">
                  <span class="button-82-shadow w-full flex"></span>
                  <span class="button-82-edge w-full flex"></span>
                  <span class="button-82-front w-full text flex">
                    <div class="flex flex-row gap-4 w-full justify-center">
                      <span> BUY NOW </span>
                    </div>
                  </span>
                </button>
              </div>
              <div class="flex w-full ">
                <button matTooltip="Add to Cart, download the PDF later from the cart" (click)="addToCart()"
                  aria-label="add to Cart button" class="button-black-88-pushable  w-full  flex" role="button">
                  <span class="button-black-88-shadow w-full flex"></span>
                  <span class="button-black-88-edge w-full flex"></span>
                  <span class="button-black-88-front w-full text flex">
                    <div class="flex flex-row gap-4 w-full justify-center">
                      <span> ADD TO CART </span>
                    </div>
                  </span>
                </button>
              </div>
            </ng-container>

            <!-- CALL TO INQUIRE Button when pleaseContactForPrice is true -->
            <div class="flex w-full" *ngIf="product!.pleaseContactForPrice">
              <button (click)="callNumber('0772553478')" class="button-82-pushable w-full flex animate__animated animate__pulse animate__infinite animate__slower" role="button">
                <span class="button-82-shadow w-full flex"></span>
                <span class="button-82-edge w-full flex"></span>
                <span class="button-82-front w-full text flex">
                  <div class="flex flex-row gap-4 w-full justify-center items-center">
                    <span> CALL TO INQUIRE </span>
                  </div>
                </span>
              </button>
            </div>


          </div>
          <div class="flex flex-row justify-center gap-2 items-center w-full py-6">
            <p>Do you like this product? save this spec as an image</p>
            <button (click)="downloadCanvasAsImage()" matTooltip="Download this page, no need to screenshot"
              aria-label="add to Cart button"
              class="text-[#ff4d06] bg-black border-0 py-2 px-6 focus:outline-none hover:bg-red-900 rounded font-bold text-2xl flex w-[100px] items-center justify-center">
              <img src="../../../assets/graphics/icons8-screenshot-50.png" alt="Screenshot icon" width="24" height="24" loading="eager" />
            </button>
          </div>

          <!-- Payment Information Grid -->
          <app-bank-grid [price]="product!.newPrice!" [kokoInstallmentPrice]="!product!.pleaseContactForPrice ? kokoInstallmentPrice : 0"></app-bank-grid>
        </div>
      </div>
    </div>

    <div class="container py-2 mx-auto" *ngIf="showCompatibles">
      <div class="flex flex-wrap w-full mb-4">
        <div class="lg:w-1/3 w-full mb-6 lg:mb-0">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
            Goes well with
          </h1>
          <div class="h-1 w-20 bg-[#ff4d06] rounded"></div>
        </div>
        <p class="lg:w-2/3 w-full leading-relaxed text-gray-500">
          Spot on: Dive deeper into your tech setup! These curated picks are the
          perfect complements to your stunning
          <strong>{{ product.label }}</strong> . They're like the essential
          companions, ready to unlock a world of productivity possibilities. Mix
          and match to create a tech setup that's uniquely you, or discover
          hidden gems that boost your productivity. Get ready to shine!
        </p>
      </div>

      <app-product-grid1 [isSS]="isSS" [filteredItems]="product.compatibleItems!"></app-product-grid1>
    </div>

    <div class="flex flex-col md:flex-row items-center justify-center" *ngIf="isSS">
      <img src="../../../assets/branding/softnet-negombo-best-computer-store.webp" alt="Softnet Negombo Store Logo" style="width: 30px" />
      &nbsp;
      <span class="text-center">
        softnetcomputers.lk 077-255 3478 designed and developed by &nbsp;
      </span>
      <img src="../../../assets/branding/logo-black.png" alt="Softnet Computers Black Logo" style="width: 30px" />
      <span class="text-center">&nbsp; theheavenscode.com 077-402 8857 </span>
      <br>
      <br>
    </div>
  </div>
</section>

<app-footer></app-footer>